import { Module } from "vuex";
import { RootState } from "..";
import { AUTH_ACTIONS } from "./auth.actions";
import { AUTH_MUTATIONS } from "./auth.mutations";
import { AUTH_GETTERS } from "./auth.getters";
import { RegisterForm } from "@/interfaces/auth/register-form.model";
import { LoginForm } from "@/interfaces/auth/login-form.model";

export interface AuthState {
  authentication: string;
  loading: boolean;
  registerForm: RegisterForm;
  loginForm: LoginForm;
}

const INITIAL_STATE: AuthState = {
  authentication: "login",
  loading: false,
  // register form
  registerForm: {
    mobile: "",
    password: "",
    confirm: "",
    deviceType: "web"
  },
  // login form
  loginForm: {
    mobile: "",
    password: "",
    acode: ""
  }
};

export const auth: Module<AuthState, RootState> = {
  actions: AUTH_ACTIONS,
  getters: AUTH_GETTERS,
  mutations: AUTH_MUTATIONS,
  state: INITIAL_STATE,
  namespaced: true,
};
